// extracted by mini-css-extract-plugin
module.exports =  {"container":"e2ff468f85--container--C7hn2","background":"e2ff468f85--background--KV7Ke","image":"e2ff468f85--image--xN0Ub","footnote":"e2ff468f85--footnote--TDQy5"};